<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Drug age-ranges",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Pharmacy Drug age-ranges",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Drug age-ranges",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      nameError: "",
      FromError: "",
      ToError: "",
      AgeunitError: "",
      DoseError: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "drug",
          sortable: true,
          label: "NAME",
        },
        {
          key: "from",
          sortable: true,
          label: "FROM AGE",
        },
        {
          key: "to",
          sortable: true,
          label: "TO AGE",
        },
        {
          key: "age_unit",
          sortable: true,
          label: "AGE UNIT",
        },
        {
          key: "prescription",
          sortable: true,
          label: "PRESCRIPTION",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        }
      ],     

      // Value from user input for adding category
      data: {
        drug: "",
        from: "",
        to: "",
        age_unit: "",
        description: "",
      },
      // edit cat
      editdata: {
        drug: "",
        from: "",
        to: "",
        age_unit: "",
        description: "",
        id: "",
      },
      // delete cat
      deletedata: {
        drug: "",
        description: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("pharmacy", ["PharmacyItems", "DrugAgeRange", "DrugageState"]),

    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.DrugAgeRange ? this.DrugAgeRange.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.DrugAgeRange ? this.DrugAgeRange.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      FetchDrugAge: "pharmacy/fetchDrugageRange",
      AddDrugAgeRange: "pharmacy/addDrugageRange",
      EditDrugAgeRange: "pharmacy/editDrugageRange",
      DeleteDrugAgeRange: "pharmacy/deleteDrugageRange",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addDrugAge(modalId) {
      this.modal_id = modalId;

      if (this.data.drug === "") {
        this.nameError = "Drug name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.from === "") {
        this.FromError = "From age field is required";
        return;
      } else {
        this.FromError = "";
      }
      if (this.data.to === "") {
        this.ToError = "To age field is required";
        return;
      } else {
        this.ToError = "";
      }
      if (this.data.age_unit === "") {
        this.AgeunitError = "Age unit field is required";
        return;
      } else {
        this.AgeunitError = "";
      }
      if (this.data.prescription === "") {
        this.DoseError = "Prescription field is required";
        return;
      } else {
        this.DoseError = "";
      }
      this.AddDrugAgeRange(this.data);
    },

    resetAddDrugAge() {
      this.data.drug = "";
      this.data.from = "";
      this.data.to = "";
      this.data.prescription = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditDrugAgeRange() {
      this.editdata.drug = "";
      this.editdata.from = "";
      this.editdata.to = "";
      this.editdata.prescription = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteDrugAgeRange() {
      this.deletedata.drug = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.FromError = "";
      this.ToError = "";
      this.AgeunitError = "";
      this.DoseError = "";
    },
    resetEditError() {
      this.nameError = "";
      this.FromError = "";
      this.ToError = "";
      this.AgeunitError = "";
      this.DoseError = "";
    },
    showEditModal(data) {
      this.editdata.drug = data.item.drug;
      this.editdata.from = data.item.from;
      this.editdata.to = data.item.to;
      this.editdata.prescription = data.item.prescription;
      this.editdata.id = data.item.id;
    },
    Edit_DrugAgeRange(modalId) {
      this.modal_id = modalId;
      if (this.editdata.drug === "") {
        this.nameError = "Drug name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.from === "") {
        this.FromError = "From age field is required";
        return;
      } else {
        this.FromError = "";
      }
      if (this.editdata.to === "") {
        this.ToError = "To age field is required";
        return;
      } else {
        this.ToError = "";
      }
      if (this.editdata.age_unit === "") {
        this.AgeunitError = "Age unit field is required";
        return;
      } else {
        this.AgeunitError = "";
      }
      if (this.editdata.prescription === "") {
        this.DoseError = "Prescription field is required";
        return;
      } else {
        this.DoseError = "";
      }
      this.EditDrugAgeRange(this.editdata);
    },
    showDeleteModal(data) {
      this.editdata.drug = data.item.drug;
      this.deletedata.symbol = data.item.symbol;
      this.deletedata.id = data.item.id;
    },
    delete_DrugAgeRange(modalId) {
      this.modal_id = modalId;
      this.DeleteDrugAgeRange(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchPharmacyItems();
    this.FetchDrugAge();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-drugage-modal
                    ><i class="fa fa-plus"></i> New range</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-drugage-modal" hide-footer @hidden="resetAddDrugAge">
                    <template #modal-title> Add new drug prescription age_range</template>
                    <div class="form-group mb-3">
                      <label>Drug name</label>
                      <model-list-select
                        :list="PharmacyItems ? PharmacyItems : []"
                        v-model="data.drug"
                        option-value="id"                        
                        @input="resetError"
                        placeholder="Select drug"
                        option-text="serviceName"
                      >
                      </model-list-select>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>From age</label>
                      <div class="input-group">
                        <input
                          type="number"
                          placeholder="Enter age number"
                          class="form-control"
                          @input="resetError"
                          v-model="data.from"
                        />
                      </div>
                      <div class="text-danger" v-if="FromError">
                        <em>{{ FromError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>To age</label>
                      <div class="input-group">
                        <input
                          type="number"
                          placeholder="Enter age number"
                          class="form-control"
                          @input="resetError"
                          v-model="data.to"
                        />
                      </div>
                      <div class="text-danger" v-if="ToError">
                        <em>{{ ToError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label class="col-form-label">Age Unit<span class="text-danger">*</span></label>
                        <select class="form-control" @input="resetError" v-model="data.age_unit">
                          <option value="1">Years</option>
                          <option value="2">Months</option>
                          <option value="3">Days</option>
                        </select>
                      <div class="text-danger" v-if="AgeunitError">
                        <em>{{ AgeunitError }}</em>
                      </div>
                    </div> 
                    <div class="form-group mb-3">
                      <label>Prescription</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter prescription"
                          class="form-control"
                          @input="resetError"
                          v-model="data.prescription"
                        />
                      </div>
                      <div class="text-danger" v-if="DoseError">
                        <em>{{ DoseError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger pull-left"
                        data-dismiss="modal"
                        @click="closeModal('add-drugage-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addDrugAge('add-drugage-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="DrugageState"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="DrugAgeRange ? DrugAgeRange : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-drugage_range-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-drugage_range-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!DrugAgeRange" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-drugage_range-modal" hide-footer @hidden="resetEditDrugAgeRange">
              <template #modal-title> Edit drug prescription for {{ editdata.drug }}</template>
                  <div class="form-group mb-3">
                      <label>Drug name</label>
                      <model-list-select
                        :list="PharmacyItems ? PharmacyItems : []"
                        v-model="editdata.drug"
                        option-value="id"
                        :selected="true"                        
                        @input="resetEditError"
                        option-text="serviceName"
                      >
                      </model-list-select>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>From age</label>
                      <div class="input-group">
                        <input
                          type="number"
                          placeholder="Enter age number"
                          class="form-control"
                          @input="resetEditError"
                          v-model="editdata.from"
                        />
                      </div>
                      <div class="text-danger" v-if="FromError">
                        <em>{{ FromError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>To age</label>
                      <div class="input-group">
                        <input
                          type="number"
                          placeholder="Enter age number"
                          class="form-control"
                          @input="resetEditError"
                          v-model="editdata.to"
                        />
                      </div>
                      <div class="text-danger" v-if="ToError">
                        <em>{{ ToError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label class="col-form-label">Age Unit<span class="text-danger">*</span></label>
                        <select class="form-control" @input="resetEditError" :selected="true" v-model="editdata.age_unit">
                          <option value="1">Years</option>
                          <option value="2">Months</option>
                          <option value="3">Days</option>
                        </select>
                      <div class="text-danger" v-if="AgeunitError">
                        <em>{{ AgeunitError }}</em>
                      </div>
                    </div>                    
                    <div class="form-group mb-3">
                      <label>Prescription</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter prescription"
                          class="form-control"
                          @input="resetEditError"
                          v-model="editdata.prescription"
                        />
                      </div>
                      <div class="text-danger" v-if="DoseError">
                        <em>{{ DoseError }}</em>
                      </div>
                    </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-drugage_range-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="Edit_DrugAgeRange('edit-drugage_range-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="DrugageState"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal id="delete-drugage_range-modal" hide-footer @hidden="resetDeleteDrugAgeRange">
              <template #modal-title>
                <h4 class="text-danger">
                  Delete prescription for {{ deletedata.drug }}
                </h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this drug prescription? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-drugage_range-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="delete_DrugAgeRange('delete-drugage_range-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="DrugageState"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
